import { render, staticRenderFns } from "./Woongemeenschap.vue?vue&type=template&id=3e087894&scoped=true&"
import script from "./Woongemeenschap.vue?vue&type=script&lang=js&"
export * from "./Woongemeenschap.vue?vue&type=script&lang=js&"
import style0 from "./Woongemeenschap.vue?vue&type=style&index=0&id=3e087894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e087894",
  null
  
)

export default component.exports